import { Button } from "@shared/components/atoms/button";
import { Grid3x3, List } from "lucide-react";
import { cn } from "@shared/lib/utils";
import { useTranslation } from "@shared/locales";
import type { ViewMode } from "@shared/types";

interface ViewToggleProps {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
  className?: string;
}

export function ViewToggle({ value, onChange, className }: ViewToggleProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-lg border border-border p-1",
        className
      )}
    >
      <Button
        type="button"
        variant={value === "grid" ? "default" : "ghost"}
        size="sm"
        onClick={() => onChange("grid")}
        aria-label={t("viewToggle.grid")}
      >
        <Grid3x3 className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant={value === "list" ? "default" : "ghost"}
        size="sm"
        onClick={() => onChange("list")}
        aria-label={t("viewToggle.list")}
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
}
